// extracted by mini-css-extract-plugin
export var banner = "_ei-0";
export var closeButton = "_ei-2";
export var greenCheckmark = "_ei-3";
export var hereLink = "_ei-4";
export var titleIcon = "_ei-1";